import AgendaWidget from "./AgendaWidget";
import SpeakerWidget from "./SpeakerWidget";
import SponsorWidget from "./SponsorWidget";
import CalendarWidget from "./CalendarWidget";
import Widget from "./Widget";
import SubscribeWidget from "./SubscribeWidget";

export {AgendaWidget, SpeakerWidget, Widget, SponsorWidget, SubscribeWidget, CalendarWidget};


// WEBPACK FOOTER //
// ./src/embed/widgets/index.es6